var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card-footer-item",class:_vm.deleteButtonClass,on:{"click":function($event){return _vm.clickDeleteFavouriteGroup()}}},[_vm._v(_vm._s(_vm.deleteText))])}
var staticRenderFns = []

export { render, staticRenderFns }